export default "__VITE_ASSET__f484459a__"